import { IFinalResponse, MetadataTypes } from '../types';

export const getReturnResponseDefault = (
  metadata: MetadataTypes = {
    machineName: '',
    machineVersion: '0.0.1',
  },
): IFinalResponse => {
  return {
    errors: {
      flow: {},
      infos: {},
      details: [],
    },
    success: false,
    data: null,
    metadata,
  };
};
